import { useRewardsStore } from '@/store/rewards.store';
import { useEggProgress } from '@/hooks/useEggProgress';
import { useHatchEgg } from '@/hooks/useHatchEgg';
import { HatcherySlot } from './HatcherySlot';

const MAX_SLOTS = 2;

export function Hatchery() {
  const activeEggs = useRewardsStore((s) => s.activeEggs);
  const progressMap = useEggProgress(activeEggs);
  const { hatch, hatching } = useHatchEgg();

  const slots = Array.from({ length: MAX_SLOTS }, (_, i) => activeEggs[i] ?? null);

  return (
    <section>
      <h2 className="text-2xl font-display font-bold text-stone-900 mb-1">In the Nest</h2>
      <p className="text-sm text-stone-500 mb-5">
        Up to {MAX_SLOTS} eggs can incubate at once. Tap to hatch when the timer hits zero.
      </p>
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        {slots.map((egg, i) => (
          <HatcherySlot
            key={egg?.id ?? `empty-${i}`}
            egg={egg ?? undefined}
            progress={egg ? (progressMap.get(egg.id) ?? 0) : 0}
            onHatch={hatch}
            hatching={hatching}
          />
        ))}
      </div>
    </section>
  );
}
